import { getComboBoxItemUIModel } from "./renders";
export const findComboBoxLargestValue = (model) => {
    let largestValue = "";
    let largestValueLength = 0;
    model.forEach((itemGroup) => {
        const subItems = itemGroup.items;
        if (itemGroup.caption.length > largestValueLength) {
            largestValue = itemGroup.caption;
            largestValueLength = itemGroup.caption.length;
        }
        if (subItems != null) {
            subItems.forEach(leaf => {
                if (leaf.caption.length > largestValueLength) {
                    largestValue = leaf.caption;
                    largestValueLength = leaf.caption.length;
                }
            });
        }
    });
    return largestValue;
};
export const mapValuesToItemInfo = (model, valueToItemInfo, captionToItemInfo) => {
    valueToItemInfo.clear();
    captionToItemInfo.clear();
    if (model == null) {
        return;
    }
    model.forEach((item, firstLevelIndex) => {
        const firstLevelItemInfo = {
            item: item,
            index: {
                type: "first-level",
                firstLevelIndex: firstLevelIndex
            }
        };
        // First level item
        valueToItemInfo.set(item.value, firstLevelItemInfo);
        if (item.caption) {
            captionToItemInfo.set(item.caption, firstLevelItemInfo);
        }
        // Second level items
        item.items?.forEach((subItem, secondLevelIndex) => {
            const secondLevelItemInfo = {
                item: subItem,
                index: {
                    type: "nested",
                    firstLevelIndex: firstLevelIndex,
                    secondLevelIndex: secondLevelIndex
                }
            };
            valueToItemInfo.set(subItem.value, secondLevelItemInfo);
            if (subItem.caption) {
                captionToItemInfo.set(subItem.caption, secondLevelItemInfo);
            }
        });
    });
};
export const popoverWasClicked = (event) => {
    const composedPath = event.composedPath();
    for (let index = 0; index < composedPath.length; index++) {
        const element = composedPath[index];
        const elementName = element.tagName?.toLowerCase();
        if (elementName === ("ch-popover")) {
            return true;
        }
        // The ch-popover tag does not exists in the path. There is no need to
        // check the rest of the path
        if (elementName === ("ch-combo-box-render")) {
            return false;
        }
    }
    return false;
};
export const getComboBoxItemFromMouseEvent = (event, model) => {
    event.stopPropagation();
    let elementTarget = event.target;
    // Expandable button case
    if (elementTarget.tagName?.toLowerCase() === "span") {
        elementTarget = elementTarget.parentElement;
    }
    if (elementTarget.tagName?.toLowerCase() !== "button") {
        return undefined;
    }
    const itemIndex = elementTarget.id;
    return getComboBoxItemUIModel(itemIndex, model);
};
// TODO: Add a unit test for this check
const isActiveDescendant = (item, activeDescendant) => item &&
    (item.value === activeDescendant.value ||
        (item.caption && item.caption === activeDescendant.caption));
const checkIfSecondLevelModelContainsActiveDescendant = (activeDescendant, model) => {
    for (let secondIndex = 0; secondIndex < model.length; secondIndex++) {
        const secondLevelItem = model[secondIndex];
        if (isActiveDescendant(secondLevelItem, activeDescendant)) {
            return true;
        }
    }
    return false;
};
export const comboBoxActiveDescendantIsRendered = (activeDescendant, model) => {
    if (!activeDescendant || !model) {
        return false;
    }
    for (let firstIndex = 0; firstIndex < model.length; firstIndex++) {
        const firstLevelItem = model[firstIndex];
        if (isActiveDescendant(firstLevelItem, activeDescendant)) {
            return true;
        }
        if (firstLevelItem.items != null &&
            checkIfSecondLevelModelContainsActiveDescendant(activeDescendant, firstLevelItem.items)) {
            return true;
        }
    }
    return false;
};
